export enum ActivityType {
    Other = 'Other',
    Assignment = 'Assignment',
    Course = 'Course',
    Elesson = 'Elesson',
    Exam = 'Exam',
    Forum = 'Forum',
    Document = 'Document',
    VirtualClass = 'VirtualClass',
    Container = 'Container',
    Survey = 'Survey',
    Video = 'Video',
    MorpaActivity = 'MorpaActivity',
    GenericActivity = 'GenericActivity',
    LinkActivity = 'LinkActivity',
    DersdeoActivity = 'DersdeoActivity',
    Dictionary = 'Dictionary',
    TelegramActivity = 'TelegramActivity',
    Reading = 'Reading',
    LTIActivity = 'LTIActivity',
    Project = 'Project',
    InformationNote = 'InformationNote'
}

export enum ActivityTypeEnums {
    Other = 0,
    Assignment = 2,
    Course = 3,
    Elesson = 4,
    Exam = 5,
    Forum = 6,
    Document = 7,
    VirtualClass = 8,
    Container = 9,
    Survey = 10,
    Video = 11,
    MorpaActivity = 12,
    GenericActivity = 13,
    LinkActivity = 14,
    DersdeoActivity = 15,
    Dictionary = 16,
    TelegramActivity = 17,
    Reading = 20,
    LTIActivity = 18,
    Project = 19,
    InformationNote = 21

}